import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { IfStmt } from '@angular/compiler';

@Directive({
  selector: '[valid-value]'
})
export class ValidValueDirective {
  @Input() tipoValor: string
  constructor(private el: ElementRef) { }

  private ALPHANUMERIC_ALLOWED_REGEXP = /^\w+$/;

  @HostListener("keypress", [ "$event" ]) onKeyPress(event: KeyboardEvent) {
    const keyCode = event.keyCode || event.which;
    const keyValue = event.key || String.fromCharCode(keyCode);

    let esValido = true;
    switch(this.tipoValor){
      case "alfanumerico": esValido = this.ALPHANUMERIC_ALLOWED_REGEXP.test(keyValue); break;
    }
    if (!esValido) {
      event.preventDefault();
    }
  }

  @HostListener("paste", [ "$event" ])
  blockPaste(e: any) {
    const clipboardData: any = e.clipboardData;
    const text = clipboardData.getData('text');

    let esValido = true;
    switch(this.tipoValor){
      case "alfanumerico": esValido = this.ALPHANUMERIC_ALLOWED_REGEXP.test(text); break;
    }

    if (!esValido) {
      event.preventDefault();
    }
  }
}
